import { jsx as _jsx } from "react/jsx-runtime";
import Page from "./Page";
import { useFlow } from "../hooks/df";
export default function Flow() {
    //TODO: run health check test for bad pages, bad fields
    var flow = useFlow();
    return (_jsx("div", { className: "flow", children: _jsx(Page, { flow: flow }) }));
}
;
